import { UnitType } from "app/shared/model";

const COURSE_PRODUCT_TYPE_ID = 1;

function hasAllowedProductType(unitType: UnitType, productTypeName: string, productTypeId: number): boolean {
  const allowed = unitType.allowedProductTypes ?? [];
  if (!Array.isArray(allowed) || allowed.length === 0) return false;
  return allowed.some((pt) => {
    const name = String((pt as any)?.name ?? "").trim().toLowerCase();
    const id = Number((pt as any)?.id);
    return name === productTypeName.trim().toLowerCase() || id === productTypeId;
  });
}

export function isAllowedCourseUnitType(unitType: UnitType): boolean {
  if ((unitType.allowedProductTypes ?? []).length > 0) {
    return hasAllowedProductType(unitType, "Course", COURSE_PRODUCT_TYPE_ID);
  }

  const n = (unitType.name ?? "").trim().toLowerCase().replace(/\s+/g, " ");
  if (n.includes("calendar night") && n.includes("week")) return true;
  if (/^calendar weeks?$/.test(n)) return true;
  if (n.includes("working") && n.includes("week")) return true;
  return false;
}

export function filterUnitTypesForCourse(all: UnitType[] | undefined): UnitType[] {
  return (all ?? []).filter((u) => u.id > 0 && isAllowedCourseUnitType(u));
}